import clsx from 'clsx';
import React from 'react';
import styles from './UIGameButton.module.scss';
import { AudioManager, AudioType } from '@colonist/audio';
export const UIGameButton = ({ className = '', variant = 'primary', children, disabled = false, onClick })=>/*#__PURE__*/ React.createElement("button", {
        className: clsx(styles.button, {
            [styles.primary]: variant === 'primary',
            [styles.dark]: variant === 'dark',
            [styles.outline]: variant === 'outline',
            [styles.disabled]: disabled
        }, className),
        disabled: disabled,
        onClick: disabled ? undefined : ()=>{
            AudioManager.play(AudioType.Click);
            onClick();
        }
    }, children);
